/**
 * Takes a sorted list of indexes and text and returns
 * the texts between indexes highlighted.
 * Highlighted text will be between <h></h> tags.
 * @param {string} text
 * @param {[number, number][]} indices
 * @returns {string}
 */
export function highlight(text, indices) {
    if (indices.length === 0) {
        return text
    }
    const idx = indices.shift()
    const first = text.slice(0, idx[0])
    const second = text.slice(idx[0], idx[1] + 1)
    const third = text.slice(idx[1] + 1)
    const l = (first + second).length
    const nextIndices = indices.map(idx => [idx[0] - l, idx[1] - l])
    return first + "<h>" + second + "</h>" + highlight(third, nextIndices)
}

export function highlightSearchResult(searchResult) {
    return searchResult.map(sr => {
        const title = sr.item.title
        return {
            item: {...sr.item, "highlighted-title": highlight(title, sr.indices)},
            score: sr.score,
        }
    })
}